import { Guid } from '../../../Guid';
import { DeviceTaskType } from '../IDevice';
import { DeviceControlFeature } from '../IDeviceTask';
export class DeviceTask {
    constructor() {
        this._taskType = DeviceTaskType.GetChannelsState;
        this._featureType = DeviceControlFeature.GetState;
        this._channel = 0;
        this._guid = Guid.NewGuid();
        this._deviceGuid = "";
    }
    get TaskType() {
        return this._taskType;
    }
    set TaskType(taskType) {
        this._taskType = taskType;
    }
    get FeatureType() {
        return this._featureType;
    }
    set FeatureType(featureType) {
        this._featureType = featureType;
    }
    get Guid() {
        return this._guid;
    }
    set Guid(guid) {
        this._guid = guid;
    }
    get DeviceGuid() {
        return this._deviceGuid;
    }
    set DeviceGuid(value) {
        this._deviceGuid = value;
    }
    get Channel() {
        return this._channel;
    }
    set Channel(value) {
        this._channel = value;
    }
}
//# sourceMappingURL=DeviceTask.js.map